var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-factory-check" }, [
    _c("img", {
      class: { "icon-goods": true, "xfm-img": _vm.isRyBaseVersion },
      attrs: { src: _vm.ossHost + _vm.imgUrl, alt: "" }
    }),
    _c(
      "div",
      { class: { "check-info-head": true, "xfm-head": _vm.isRyBaseVersion } },
      [
        _c("div", { staticClass: "device-number" }, [
          _vm._v(_vm._s(_vm.uniqueId))
        ]),
        !_vm.isRyBaseVersion
          ? _c("div", { staticClass: "device-type" }, [
              _vm._v(_vm._s(_vm.deviceName || "溶氧检测仪"))
            ])
          : _c("div", { staticClass: "device-type" }, [
              _vm._v("溶氧仪可视基础版")
            ])
      ]
    ),
    _c(
      "div",
      { staticClass: "check-box" },
      [
        _c(
          "Collapse",
          {
            attrs: { value: _vm.activeNames, accordion: "" },
            on: { change: _vm.onChange }
          },
          [
            _c(
              "CollapseItem",
              {
                attrs: { name: "1", disabled: _vm.passType >= 1 },
                scopedSlots: _vm._u([
                  {
                    key: "title",
                    fn: function() {
                      return [
                        _c("span", [_vm._v("一：功能检测")]),
                        _vm.passType >= 1
                          ? _c("Icon", {
                              staticClass: "collapse-pass-icon",
                              attrs: { name: "passed" }
                            })
                          : _vm._e()
                      ]
                    },
                    proxy: true
                  }
                ])
              },
              [
                !_vm.isRyBaseVersion
                  ? _c("div", { staticClass: "check-body" }, [
                      _c(
                        "div",
                        {
                          class: {
                            "refresh-btn": true,
                            disabled: _vm.loadingData
                          },
                          on: { click: _vm.refreshSignal }
                        },
                        [
                          _c("Icon", {
                            attrs: {
                              name: "replay",
                              size: "0.18rem",
                              color: "#fff"
                            }
                          }),
                          _c("span", [_vm._v("重新获取")])
                        ],
                        1
                      ),
                      _c("div", { staticClass: "content-item" }, [
                        _c("div", { staticClass: "content-item-label" }, [
                          _vm._v("信号强度已超过18 "),
                          _vm.signal
                            ? _c("b", [_vm._v("(" + _vm._s(_vm.signal) + ")")])
                            : _vm._e()
                        ]),
                        _c(
                          "div",
                          { staticClass: "content-item-value" },
                          [
                            _vm.loadingData
                              ? _c("Loading", {
                                  attrs: {
                                    size: "24",
                                    type: "spinner",
                                    color: _vm.themeColor
                                  }
                                })
                              : _vm._e(),
                            !_vm.signalPass && !_vm.loadingData
                              ? _c("Icon", { attrs: { name: "close" } })
                              : _vm._e(),
                            _vm.signalPass && !_vm.loadingData
                              ? _c("Icon", { attrs: { name: "passed" } })
                              : _vm._e()
                          ],
                          1
                        )
                      ]),
                      _c("div", { staticClass: "content-item" }, [
                        _c(
                          "div",
                          { staticClass: "content-item-label" },
                          [
                            _vm._v("探头质检 "),
                            _vm.isRepairHost && _vm.sensorPass
                              ? [
                                  _c(
                                    "span",
                                    { staticClass: "duplicate-ignored" },
                                    [_vm._v("(重复探头，已忽略)")]
                                  )
                                ]
                              : [
                                  _vm.sensorPass &&
                                  !_vm.isDuplicateSensorBlocked
                                    ? _c("b", [_vm._v("合格")])
                                    : _c("span", [_vm._v("不合格")]),
                                  _vm.sensorErrText
                                    ? _c("span", [
                                        _vm._v(
                                          "(" + _vm._s(_vm.sensorErrText) + ")"
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm.factoryDuplicate === true
                                    ? _c("span", [
                                        _vm._v(
                                          "(重复探头" +
                                            _vm._s(
                                              _vm.isRepairHost ? "，已忽略" : ""
                                            ) +
                                            ")"
                                        )
                                      ])
                                    : _vm._e()
                                ]
                          ],
                          2
                        ),
                        _c(
                          "div",
                          { staticClass: "content-item-value" },
                          [
                            _vm.loadingData
                              ? _c("Loading", {
                                  attrs: {
                                    size: "24",
                                    type: "spinner",
                                    color: _vm.themeColor
                                  }
                                })
                              : _vm._e(),
                            (!_vm.sensorPass || _vm.isDuplicateSensorBlocked) &&
                            !_vm.loadingData
                              ? _c("Icon", { attrs: { name: "close" } })
                              : _vm._e(),
                            _vm.sensorPass &&
                            !_vm.isDuplicateSensorBlocked &&
                            !_vm.loadingData
                              ? _c("Icon", { attrs: { name: "passed" } })
                              : _vm._e()
                          ],
                          1
                        )
                      ]),
                      _vm.factoryDuplicate === true
                        ? _c("div", { staticClass: "content-item" }, [
                            _c("div", { staticClass: "content-item-label" }, [
                              _vm._v("是否为返修主机")
                            ]),
                            _c(
                              "div",
                              { staticClass: "content-item-value" },
                              [
                                _c("el-switch", {
                                  attrs: {
                                    "active-color": "#209A56",
                                    "inactive-color": "#bbb"
                                  },
                                  model: {
                                    value: _vm.isRepairHost,
                                    callback: function($$v) {
                                      _vm.isRepairHost = $$v
                                    },
                                    expression: "isRepairHost"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        : _vm._e(),
                      _c("div", { staticClass: "content-item" }, [
                        _c("div", { staticClass: "content-item-label" }, [
                          _vm._v(_vm._s(_vm.warningList[0].text))
                        ]),
                        _c(
                          "div",
                          { staticClass: "content-item-value" },
                          [
                            _vm.loadingData
                              ? _c("Loading", {
                                  attrs: {
                                    size: "24",
                                    type: "spinner",
                                    color: _vm.themeColor
                                  }
                                })
                              : _vm._e(),
                            !_vm.warningList[0].pass && !_vm.loadingData
                              ? _c("Icon", { attrs: { name: "close" } })
                              : _vm._e(),
                            _vm.warningList[0].pass && !_vm.loadingData
                              ? _c("Icon", { attrs: { name: "passed" } })
                              : _vm._e()
                          ],
                          1
                        )
                      ]),
                      _c("div", { staticClass: "content-item" }, [
                        _c(
                          "div",
                          { staticClass: "content-item-label" },
                          [
                            _vm._v("30分钟内主机正常充排气 "),
                            _vm.adErrText
                              ? _c("span", [_vm._v(_vm._s(_vm.adErrText))])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.pumpStatus
                              ? _c("span", [_vm._v("(气泵已关闭)")])
                              : _vm._e(),
                            _vm.pumpStatus
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "primary",
                                      size: "mini",
                                      loading: _vm.updatePumpStatusLoading
                                    },
                                    on: { click: _vm.onclickUpdatePumpBtn }
                                  },
                                  [_vm._v("打开气泵")]
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "content-item-value" },
                          [
                            _vm.loadingData
                              ? _c("Loading", {
                                  attrs: {
                                    size: "24",
                                    type: "spinner",
                                    color: _vm.themeColor
                                  }
                                })
                              : _vm._e(),
                            !_vm.motorPass && !_vm.loadingData
                              ? _c("Icon", { attrs: { name: "close" } })
                              : _vm._e(),
                            _vm.motorPass && !_vm.loadingData
                              ? _c("Icon", { attrs: { name: "passed" } })
                              : _vm._e()
                          ],
                          1
                        )
                      ]),
                      _c("div", { staticClass: "content-item" }, [
                        _c("div", { staticClass: "content-item-label" }, [
                          _vm._v("设备倾斜角度检测(15°)")
                        ]),
                        _c(
                          "div",
                          { staticClass: "content-item-value" },
                          [
                            _vm.loadingData
                              ? _c("Loading", {
                                  attrs: {
                                    size: "24",
                                    type: "spinner",
                                    color: _vm.themeColor
                                  }
                                })
                              : _vm._e(),
                            !_vm.anglePass && !_vm.loadingData
                              ? _c("Icon", { attrs: { name: "close" } })
                              : _vm._e(),
                            _vm.anglePass && !_vm.loadingData
                              ? _c("Icon", { attrs: { name: "passed" } })
                              : _vm._e()
                          ],
                          1
                        )
                      ]),
                      _vm.hasHardwareResetError
                        ? _c("div", { staticClass: "content-item" }, [
                            _c("div", { staticClass: "content-item-label" }, [
                              _vm._v("主板经常硬件复位")
                            ]),
                            _c(
                              "div",
                              { staticClass: "content-item-value" },
                              [_c("Icon", { attrs: { name: "close" } })],
                              1
                            )
                          ])
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm.ryType < 17
                  ? _c("div", { staticClass: "check-box" }, [
                      _c("div", { staticClass: "check-body" }, [
                        _c("div", { staticClass: "content-item" }, [
                          _c("div", { staticClass: "content-item-label" }, [
                            _vm._v("不含压力开关,无需进行气路检测")
                          ]),
                          _c(
                            "div",
                            { staticClass: "content-item-value" },
                            [
                              _c("el-switch", {
                                attrs: {
                                  "active-color": "#209A56",
                                  "inactive-color": "#bbb"
                                },
                                on: {
                                  click: function($event) {
                                    _vm.notPumpCheck = !_vm.notPumpCheck
                                  }
                                },
                                model: {
                                  value: _vm.notPumpCheck,
                                  callback: function($$v) {
                                    _vm.notPumpCheck = $$v
                                  },
                                  expression: "notPumpCheck"
                                }
                              })
                            ],
                            1
                          )
                        ]),
                        _vm.hasHardwareResetError
                          ? _c("div", { staticClass: "content-item" }, [
                              _c("div", { staticClass: "content-item-label" }, [
                                _vm._v("主板经常硬件复位")
                              ]),
                              _c(
                                "div",
                                { staticClass: "content-item-value" },
                                [_c("Icon", { attrs: { name: "close" } })],
                                1
                              )
                            ])
                          : _vm._e()
                      ])
                    ])
                  : _vm._e(),
                _vm.isRyBaseVersion
                  ? _c("div", { staticClass: "check-body" }, [
                      _c(
                        "div",
                        {
                          class: {
                            "refresh-btn": true,
                            disabled: _vm.loadingData
                          },
                          on: { click: _vm.refreshSignal }
                        },
                        [
                          _c("Icon", {
                            attrs: {
                              name: "replay",
                              size: "0.18rem",
                              color: "#fff"
                            }
                          }),
                          _c("span", [_vm._v("重新获取")])
                        ],
                        1
                      ),
                      _c("div", { staticClass: "content-item" }, [
                        _c("div", { staticClass: "content-item-label" }, [
                          _vm._v("信号强度已超过18 "),
                          _vm.signal
                            ? _c("b", [_vm._v("(" + _vm._s(_vm.signal) + ")")])
                            : _vm._e()
                        ]),
                        _c(
                          "div",
                          { staticClass: "content-item-value" },
                          [
                            _vm.loadingData
                              ? _c("Loading", {
                                  attrs: {
                                    size: "24",
                                    type: "spinner",
                                    color: _vm.themeColor
                                  }
                                })
                              : _vm._e(),
                            !_vm.signalPass && !_vm.loadingData
                              ? _c("Icon", { attrs: { name: "close" } })
                              : _vm._e(),
                            _vm.signalPass && !_vm.loadingData
                              ? _c("Icon", { attrs: { name: "passed" } })
                              : _vm._e()
                          ],
                          1
                        )
                      ]),
                      _c("div", { staticClass: "content-item" }, [
                        _c("div", { staticClass: "content-item-label" }, [
                          _vm._v("探头空气饱和氧偏差小于10% ")
                        ]),
                        _c(
                          "div",
                          { staticClass: "content-item-value" },
                          [
                            _vm.loadingData
                              ? _c("Loading", {
                                  attrs: {
                                    size: "24",
                                    type: "spinner",
                                    color: _vm.themeColor
                                  }
                                })
                              : _vm._e(),
                            !_vm.fullOxyPass && !_vm.loadingData
                              ? _c("Icon", { attrs: { name: "close" } })
                              : _vm._e(),
                            _vm.fullOxyPass && !_vm.loadingData
                              ? _c("Icon", { attrs: { name: "passed" } })
                              : _vm._e()
                          ],
                          1
                        )
                      ]),
                      _c("div", { staticClass: "content-item" }, [
                        _c("div", { staticClass: "content-item-label" }, [
                          _vm._v("探头零氧小于0.3")
                        ]),
                        _c(
                          "div",
                          { staticClass: "content-item-value" },
                          [
                            _vm.loadingData
                              ? _c("Loading", {
                                  attrs: {
                                    size: "24",
                                    type: "spinner",
                                    color: _vm.themeColor
                                  }
                                })
                              : _vm._e(),
                            !_vm.zeroOxyPass && !_vm.loadingData
                              ? _c("Icon", { attrs: { name: "close" } })
                              : _vm._e(),
                            _vm.zeroOxyPass && !_vm.loadingData
                              ? _c("Icon", { attrs: { name: "passed" } })
                              : _vm._e()
                          ],
                          1
                        )
                      ]),
                      _vm.hasHardwareResetError
                        ? _c("div", { staticClass: "content-item" }, [
                            _c("div", { staticClass: "content-item-label" }, [
                              _vm._v("主板经常硬件复位")
                            ]),
                            _c(
                              "div",
                              { staticClass: "content-item-value" },
                              [_c("Icon", { attrs: { name: "close" } })],
                              1
                            )
                          ])
                        : _vm._e()
                    ])
                  : _vm._e()
              ]
            ),
            !_vm.isRyBaseVersion
              ? _c(
                  "CollapseItem",
                  {
                    attrs: {
                      name: "2",
                      disabled:
                        _vm.passType != 1 || _vm.isDuplicateSensorBlocked
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "title",
                          fn: function() {
                            return [
                              _c("span", [_vm._v("二：气路检测")]),
                              _vm.pumpPass && !_vm.hasHardwareResetError
                                ? _c("Icon", {
                                    staticClass: "collapse-pass-icon",
                                    attrs: { name: "passed" }
                                  })
                                : _vm._e(),
                              !(_vm.pumpPass && !_vm.hasHardwareResetError) &&
                              _vm.pumpCheckErrorText
                                ? _c("Icon", {
                                    staticClass: "collapse-close-icon",
                                    attrs: { name: "close" }
                                  })
                                : _vm._e(),
                              _vm.pumpCheckErrorText
                                ? _c(
                                    "span",
                                    { staticClass: "collapse-error-text" },
                                    [
                                      _vm._v(
                                        "(" +
                                          _vm._s(_vm.pumpCheckErrorText) +
                                          ")"
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm.passType < 1
                                ? _c(
                                    "span",
                                    { staticClass: "collapse-error-text" },
                                    [_vm._v("请先完成功能检测")]
                                  )
                                : _vm._e()
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      2886641720
                    )
                  },
                  [
                    _c("div", { staticClass: "check-box bg-style1" }, [
                      _c("div", { staticClass: "check-body" }, [
                        _c("div", { staticClass: "content-item" }, [
                          _c(
                            "div",
                            {
                              staticClass: "content-item-label pump-tip-label"
                            },
                            [_vm._v("1：需盒盖后进行检测")]
                          )
                        ]),
                        _c("div", { staticClass: "content-item" }, [
                          _c(
                            "div",
                            {
                              staticClass: "content-item-label pump-step-label"
                            },
                            [_vm._v("2：持续1分钟，系统自动检测气路是否正常")]
                          )
                        ]),
                        _c(
                          "div",
                          { staticClass: "content-item" },
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "pump-check-btn",
                                attrs: {
                                  type: "primary",
                                  size: "large",
                                  loading: _vm.pumpLoad
                                },
                                on: { click: _vm.onClickShowStartCheckModalBtn }
                              },
                              [_vm._v(_vm._s(_vm.pumpBtnText))]
                            )
                          ],
                          1
                        )
                      ])
                    ])
                  ]
                )
              : _vm._e()
          ],
          1
        )
      ],
      1
    ),
    !_vm.isRyBaseVersion
      ? _c("div", { staticClass: "footer" }, [
          _vm.activeNames == 1
            ? _c(
                "div",
                {
                  class: {
                    btn: true,
                    pass:
                      _vm.signalPass &&
                      _vm.warningList[0].pass &&
                      _vm.motorPass &&
                      !_vm.errorStatus &&
                      _vm.sensorPass &&
                      !_vm.isDuplicateSensorBlocked &&
                      _vm.anglePass &&
                      !_vm.hasHardwareResetError
                  },
                  on: { click: _vm.passAction }
                },
                [_vm._v(" 功能质检通过 ")]
              )
            : _vm._e(),
          _vm.activeNames == 2
            ? _c(
                "div",
                {
                  class: {
                    btn: true,
                    pass:
                      _vm.pumpPass &&
                      !_vm.isDuplicateSensorBlocked &&
                      !_vm.hasHardwareResetError
                  },
                  on: { click: _vm.passAction }
                },
                [_vm._v(" 气路质检通过 ")]
              )
            : _vm._e(),
          _vm.passType == 2
            ? _c("div", { class: { btn: true } }, [_vm._v(" 整机已质检通过 ")])
            : _vm._e()
        ])
      : _c("div", { staticClass: "footer" }, [
          _c(
            "div",
            {
              class: {
                btn: true,
                pass:
                  _vm.signalPass &&
                  _vm.fullOxyPass &&
                  _vm.zeroOxyPass &&
                  !_vm.hasHardwareResetError
              },
              on: { click: _vm.passAction }
            },
            [_vm._v(" 质检通过 ")]
          )
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }